'use strict';

angular.module('shiftTraderApp')
    .controller('BaseDayOffRequestCtrl', function ($scope,
                                         $rootScope, AvailabilityRules, SAErrorHandler, flash,
                                         Session, TimeService, $state, WorkPeriods, TempAppStorage,
                                          DayOffLimitStore, DaysOffStore) {
    var _this = this;

    $scope.startOfWeekDay = Session.getStartOfWeekDay();
    $scope.dateToday = TimeService.getNowInStoreTime().toDate();
    $scope.workDayStartHour = Session.getWorkDayStartHour();

    $scope.state = {
      requestInProgress: false,
      checkingCurrentSchedule: false,
      scheduleOverlapsWithRequest: false,
      checksFinished: false
    };

    $scope.checks = {
      overlappingWorkPeriods: {
        check_run: false,
        _collapsed: true
      },
      overlappingDayOffRequests: {
        check_run: false,
        _collapsed: true
      },
      limitChecks: {
        check_run: false,
        _collapsed: true,
        num_entries: 0
      }
    };

    function updateChecksFinished() {
      $scope.state.checksFinished = lodash.every($scope.checks, function(obj) {
        return obj.check_run;
      });
    }

    $scope.goToDayoff = function(dayOff) {
      dayOff._isActive = true;
      $state.go('profile.daysOff.show', {userId: dayOff.user_id, dayOffId: dayOff.id});
    };

    function checkDayOffRequests(rangeTwix) {
      var existingRules = lodash.filter($scope.user.time_off_rules, function(r) {
        return r._type === 'single' && r.active;// && r.approved_by !== null;
      });

      var requests = lodash.filter(existingRules, function(rule) {
        return rule.range_twix.overlaps(rangeTwix) && Math.abs(rule.range_twix.intersection(rangeTwix).length('minutes')) > 0;
      });

      $scope.checks.overlappingDayOffRequests = {
        num_entries: requests.length,
        entries: requests,
        check_run: true
      };
      updateChecksFinished();
    }

    function addLimitCheckEntry(position, dtTwix, limitRecord) {
      if (!$scope.checks.limitChecks.entries) {
        $scope.checks.limitChecks.entries = [];
        $scope.checks.limitChecks.num_entries = 0;
      }

      $scope.checks.limitChecks.entries.push({
        position: position,
        dtTwix: dtTwix,
        limitRecord: limitRecord,
        message: limitRecord.$getLatestMessage()
      });

      $scope.checks.limitChecks.num_entries = $scope.checks.limitChecks.entries.length;
    }

    function calcRequestPositionRelativeToLimit(weekIdx, dayIdx, optionalDayOff) {
      var dtTwix = $scope.dataByWeek[weekIdx].days[dayIdx].range_twix;

      DaysOffStore.getDaysOffIntersectingDate(dtTwix.start)
        .then(function(daysOff) {
          var filteredSortedDaysOff = lodash.sortBy(lodash.filter(daysOff, function(dayOff) {
            return dayOff.$isPending() || dayOff.$isApproved();
          }), function(dayOff) {
            return dayOff._created_at_unix;
          });

          if (optionalDayOff) {
            var idx = lodash.findIndex(filteredSortedDaysOff, {id: optionalDayOff.id});
            if (idx > -1) {
              $scope.dataByWeek[weekIdx].days[dayIdx].limitPosition = idx + 1;
            }
          } else {
            $scope.dataByWeek[weekIdx].days[dayIdx].limitPosition = filteredSortedDaysOff.length + 1;
          }

          DayOffLimitStore.getLimitForDate(dtTwix.start)
            .then(function(limitRecord) {
              // this is a new request, so it's always the last one
              var cls = 'no-limit';

              if (!lodash.isNull(limitRecord)) {
                $scope.dataByWeek[weekIdx].days[dayIdx].limitRecord = limitRecord;

                if ($scope.dataByWeek[weekIdx].days[dayIdx].limitPosition > limitRecord.limit) {
                  cls = 'over-limit';
                  addLimitCheckEntry($scope.dataByWeek[weekIdx].days[dayIdx].limitPosition, dtTwix, limitRecord);

                } else if ($scope.dataByWeek[weekIdx].days[dayIdx].limitPosition < limitRecord.limit) {
                  cls = 'under-limit';
                } else if ($scope.dataByWeek[weekIdx].days[dayIdx].limitPosition === limitRecord.limit) {
                  cls = 'at-limit';
                }
              }

              if (cls !== '') {
                $scope.dataByWeek[weekIdx].days[dayIdx]._cssClasses[cls] = true;
              }

              $scope.checks.limitChecks.check_run = true;
              updateChecksFinished();

            }, function() {
              console.log('limit issue');
            });

        }, function() {
          console.log('issue pulling daysOff');
        });

    }


    function setupWeekCalendar(rangeTwix, optionalDayOff) {

      var currentDate = moment(rangeTwix.start);
      var firstWeek = TimeService.getWeekTwixFromMoment(moment(currentDate).startOf('week'));
      var startOfMonth = moment((TimeService.getWeekTwixFromMoment(moment(currentDate).startOf('month'))).end).startOf('month');

      $scope.weeks = lodash.map([0,1,2,3,4], function(x) {
        return (moment(firstWeek.start).add(x, 'weeks')).twix(moment(firstWeek.start).add(x+1, 'weeks'));
      });

      $scope.datesByWeek = lodash.map($scope.weeks, function(week) {
        return lodash.map(lodash.range(7), function(dayNum) {
          return moment(week.start).add(dayNum, 'days').twix(moment(week.start).add(dayNum + 1, 'days'));
        });
      });

      var isMultiDayRequest = rangeTwix.start.dayOfYear() !== rangeTwix.end.dayOfYear();
      var relativePositionLimitAnalysisToExec = [];

      var dayStartHour = Session.getWorkDayStartHour();

      $scope.dataByWeek = lodash.map($scope.datesByWeek, function (weekOfDays, weekIdx) {
        return {
          week: $scope.weeks[weekIdx],
          days: lodash.map(weekOfDays, function (dt, dayIdx) {
            // return ._cssClasses;
            // need to know what is previous or next month
            // need to know if this day is affected by the request

            var dtIntersection = dt.overlaps(rangeTwix) ? Math.abs(rangeTwix.intersection(dt).length('minutes')) : 0;

            var temp = {
              range_twix: dt,
              _cssClasses: {
                previous_month: dt.start.isBefore(startOfMonth),
                next_month: dt.start.isAfter(moment(startOfMonth).endOf('month')),
                request_overlaps_day: (!isMultiDayRequest && dtIntersection > 0) || (isMultiDayRequest && dtIntersection > ( dayStartHour * 60)), // if this is a single day request OR if the request overlaps the day by MORE than dayStartHour hrs, then show it.
                complete_overlap: dt.overlaps(rangeTwix) &&
                (rangeTwix.start.isBefore(dt.start) || rangeTwix.start.isSame(dt.start)) &&
                (rangeTwix.end.isAfter(dt.end) || rangeTwix.end.isSame(dt.end))
              }
            };

            if ((!optionalDayOff || (optionalDayOff.$isApproved() || optionalDayOff.$isPending())) && (temp._cssClasses.request_overlaps_day || temp._cssClasses.complete_overlap)) {
              // pull up the limit on that day AND all DaysOff records on that day to calculate where this request is on each day
              relativePositionLimitAnalysisToExec.push([weekIdx, dayIdx, optionalDayOff]);
            }

            return temp;
          })
        };
      });

      lodash.each(relativePositionLimitAnalysisToExec, function(x) {
        calcRequestPositionRelativeToLimit(x[0], x[1], x[2]);
      });
    }




    function getRequestLimitsAndCheck(x, y) {
      setupWeekCalendar(x, y);
    }

    function getWorkPeriodsAndCheckOverlap(rangeTwix) {
      var requestRange = rangeTwix;

      WorkPeriods.getByUserId($scope.user.id, {
        start_time: moment(requestRange.start).subtract(1, 'days').format('YYYY-MM-DD'),
        end_time: moment(requestRange.end).add(1, 'days').format('YYYY-MM-DD')
      }).then(function(workPeriods) {
        $scope.state.checkingCurrentSchedule = false;

        $scope.overlappingWorkPeriods = lodash.filter(workPeriods, function (wp) {
          return wp.range_twix.overlaps(requestRange) && Math.abs(wp.range_twix.intersection(requestRange).length('minutes')) > 0;
        });

        $scope.checks.overlappingWorkPeriods = {
          num_entries: $scope.overlappingWorkPeriods.length,
          entries: $scope.overlappingWorkPeriods,
          check_run: true
        };

        updateChecksFinished();

        $scope.state.checkingCurrentSchedule = false;

        if ($scope.overlappingWorkPeriods.length > 0) {
          $scope.state.scheduleOverlapsWithRequest = true;
          $scope.state.requestInProgress = false;
        } else {
          $scope.state.scheduleOverlapsWithRequest = false;
        }
      }, function() {

      });
    }


    _this.runChecks = function(rangeTwix, optionalDayOff) {
      checkDayOffRequests(rangeTwix);
      getWorkPeriodsAndCheckOverlap(rangeTwix);
      getRequestLimitsAndCheck(rangeTwix, optionalDayOff);
    };

    $scope.getLinkUrl = function(wp) {
      return '#/workPeriods/' + wp.id;
    };
  });
